module.exports = __webpack_public_path__ + "static/media/horse-with-mask.b59fe150.gif";